export default __webpack_public_path__ + "static/media/close-icon.3679f386.svg";